/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = ["input[_ngcontent-%COMP%] {\n  left: -9999em;\n  position: absolute; }\n\n.label[_ngcontent-%COMP%] {\n  background-image: url(//eweb8.vfd2-testnet.de/simplicity/assets/css/img/icon/unchecked.png);\n  min-height: 16px;\n  background-position: 0 50%;\n  background-repeat: no-repeat;\n  font-weight: 400;\n  padding: 4px 0 3px 30px;\n  margin-bottom: 0; }\n  .label.checked[_ngcontent-%COMP%] {\n    background-image: url(//eweb8.vfd2-testnet.de/simplicity/assets/css/img/icon/checked.png);\n    font-weight: 700; }\n\n.fm-data[_ngcontent-%COMP%] {\n  display: flex;\n  align-items: center; }\n\nfieldset[_ngcontent-%COMP%] {\n  border: none;\n  padding: 0; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/checkbox/checkbox.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 